import React,{useState, useEffect}  from 'react';
import Sides from '../Bars/Csidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Celement(){

    const [padding, setWindowpadding] = useState(0);
    const [width, setWindowWidth] = useState(0);
    useEffect(() => {
      updateDimensions()
  
      window.addEventListener('resize', updateDimensions)
      return () => window.removeEventListener('resize', updateDimensions)
    }, [])
  
    const updateDimensions = () => {
      const width = window.innerWidth
      setWindowWidth(width)
      if (width < 998) {
        setWindowpadding(2.5)
      } else {
        setWindowpadding(14)
      }
    }
  
    
    const right = {
      padding: '0 0 0 '+padding+'rem',
    };
return(
    <div>
           <Sides/>
         <Helmet>
 
 <title>Basic element in c tutorial For Beginners</title>
 <meta name="description" content="Basic element in c tutorial for beginners.Basic element computer programming in c,CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,C element programming language,Character Element in C tutorial for begineers,learn code in free," />
 <link rel="canonical" href="https://www.codeexampler.com/c-element" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Basic element computer programming in c
</h1>
<div className="first">
<a href="/c-scope-of-variable">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-keyword">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">1, The character set in a C Programming language:
</h2>
<p className="m-4 para"> Letters = a-z,A-Z,( _ underscope)<br/>
Digits  = (0,1,2,----,8,9,10)<br/>
Special symbols=( ; , ! @ # $ % ^ &#38; * ” ? /. &#62; &#60; , ) &#123; : &#125; ’[ ]<br/>
Total character is 256
ASCII-American standard coded information interchange
</p>
<h2 className="mt-4 mh2">2,Constant in a c programming language(literals):
</h2>
<h3 className="mt-4 mh3">There are two types of constant computer programming in c:
</h3>
<h4 className="mt-4">1, Primary constant<br/>
2, Secondary constant
</h4>
<h5 className="m-4">Primary Constant in c : </h5>
<p className="m-4 para">integer,real,character
</p>
<h5 className="m-4">Secondary Constant in c:</h5>
<p className="m-4 para">array,pointer,structure,union,enum,etc.
</p>
<h3 className="mt-4 mh3">Integer constant in a C programming language:</h3>
<p className="m-4 para">Means not less then -32768 or  not more then 32767. ex-0,1,40,500,1000 ,+456,-688,etc
</p>
<h3 className="mt-4 mh3">Floating point or real constant in a C programming language </h3>
<p className="m-4 para"> Means It must have a decimal point ,decimal is compulsory and also no use commas or blanks.for ex-1.2,5.6,46.88,-288,642,+64.24,etc.
</p>
<h3 className="mt-4 mh3">Character in a C programming language</h3>
<p className="m-4 para">Use single alphabet, use only single-digit or single special symbol enclosed within single inverted commas.
	Ex- ’a’,’b’,’y’,’z’.
</p>
<h1 className="mt-5">  </h1>
<div className="back">
<a href="/c-scope-of-variable">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-keyword">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Celement;